// Specialty to embedded script mappings
export const specialtyMappings = {
  'Neurology': {
    script: {
      src: 'https://datawrapper.dwcdn.net/FiJUU/embed.js',
      target: '#datawrapper-vis-FiJUU'
    },
    container: {
      id: 'datawrapper-vis-FiJUU',
      minHeight: '492px'
    },
    fallback: {
      src: 'https://datawrapper.dwcdn.net/FiJUU/full.png'
    }
  },
  'Obstetrics and Gynecology': {
    script: {
      src: 'https://datawrapper.dwcdn.net/tcYbb/embed.js',
      target: '#datawrapper-vis-tcYbb'
    },
    container: {
      id: 'datawrapper-vis-tcYbb',
      minHeight: '465px'
    },
    fallback: {
      src: 'https://datawrapper.dwcdn.net/tcYbb/full.png'
    }
  },
  'Pediatrics': {
    script: {
      src: 'https://datawrapper.dwcdn.net/XU8ad/embed.js',
      target: '#datawrapper-vis-XU8ad'
    },
    container: {
      id: 'datawrapper-vis-XU8ad',
      minHeight: '492px'
    },
    fallback: {
      src: 'https://datawrapper.dwcdn.net/XU8ad/full.png'
    }
  },
  'Primary Care': {
    script: {
      src: 'https://datawrapper.dwcdn.net/zoTFK/embed.js',
      target: '#datawrapper-vis-zoTFK'
    },
    container: {
      id: 'datawrapper-vis-zoTFK',
      minHeight: '492px'
    },
    fallback: {
      src: 'https://datawrapper.dwcdn.net/zoTFK/full.png'
    }
  },
  'Psychiatry': {
    script: {
      src: 'https://datawrapper.dwcdn.net/ahK7i/embed.js',
      target: '#datawrapper-vis-ahK7i'
    },
    container: {
      id: 'datawrapper-vis-ahK7i',
      minHeight: '492px'
    },
    fallback: {
      src: 'https://datawrapper.dwcdn.net/ahK7i/full.png'
    }
  },
  'Advanced Practice Provider - Inpatient Floor/EM/Critical Care': {
    script: {
      src: 'https://datawrapper.dwcdn.net/9PDI0/embed.js',
      target: '#datawrapper-vis-9PDI0'
    },
    container: {
      id: 'datawrapper-vis-9PDI0',
      minHeight: '519px'
    },
    fallback: {
      src: 'https://datawrapper.dwcdn.net/9PDI0/full.png'
    }
  },
  'Advanced Practice Provider - Outpatient': {
    script: {
      src: 'https://datawrapper.dwcdn.net/njQ62/embed.js',
      target: '#datawrapper-vis-njQ62'
    },
    container: {
      id: 'datawrapper-vis-njQ62',
      minHeight: '519px'
    },
    fallback: {
      src: 'https://datawrapper.dwcdn.net/njQ62/full.png'
    }
  },
  'Critical Care (MICU)': {
    script: {
      src: 'https://datawrapper.dwcdn.net/UOHgv/embed.js',
      target: '#datawrapper-vis-UOHgv'
    },
    container: {
      id: 'datawrapper-vis-UOHgv',
      minHeight: '492px'
    },
    fallback: {
      src: 'https://datawrapper.dwcdn.net/UOHgv/full.png'
    }
  }
}
